import {Formik} from 'formik';
import {Button, Group} from '@mantine/core';
import {MdCheck, MdClear} from 'react-icons/md';
import {toFormikValidationSchema} from 'zod-formik-adapter';
import {FilterFormComponent} from './FilterFormComponent';
import {FilterFormSchema} from './FilterFormSchema';
import {DEFAULT_CHANNEL, useReconciliationReportsChannel} from '../../hooks/useReconciliationReports';
import {BillingChannel} from '../../types';

interface FilterFormProps {
    onApply: () => void;
}

interface FilterFormValues {
    channel: string;
}

// FNP-607: standard filter form. The single field is the (required, non-clearable)
// channel — "Clear" resets it to the STRIPE default rather than to none, because a
// channel-less reconciliation list has no meaning (channel is the required GSI key).
// No Cancel button: clicking the drawer overlay closes it (Cancel was redundant).
export const FilterForm = ({onApply}: FilterFormProps) => {
    const {channel, handleSetChannel} = useReconciliationReportsChannel();

    const initialValues: FilterFormValues = {
        channel: channel,
    };

    const onSubmit = (values: FilterFormValues) => {
        handleSetChannel(values.channel as BillingChannel);
        onApply();
    };

    return (
        <Formik<FilterFormValues>
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(FilterFormSchema)}
            onSubmit={onSubmit}
        >
            {({handleSubmit, setFieldValue}) => (
                <>
                    <FilterFormComponent/>

                    <Group justify="flex-end" gap="xs" mt="xl">
                        <Button
                            variant="outline"
                            leftSection={<MdClear/>}
                            onClick={() => {
                                // Reset to the default channel (not to none).
                                setFieldValue('channel', DEFAULT_CHANNEL);
                                handleSetChannel(DEFAULT_CHANNEL);
                            }}
                        >
                            Clear
                        </Button>
                        <Button
                            leftSection={<MdCheck/>}
                            onClick={() => handleSubmit()}
                        >
                            Apply
                        </Button>
                    </Group>
                </>
            )}
        </Formik>
    );
};
